const Repay = () => import('@/views/Repay')

export default [
  {
    path: '/repay',
    component: Repay,
    meta: { requireAuth: true }
  }
]
